import ChildrenEntities from 'publisher/components/ChildrenEntities'
import { useWebsiteSettings } from 'publisher/store'
import React from 'react'
import {
  getWebsiteStylesLayout,
  getWebsiteThemeBackground,
} from 'src/publisher/store/website-settings/website-settings-selector'
import { CommonWebsitePageBody } from 'src/shared/entities/website-page-body'
import { WebsitePageInterface } from 'src/shared/types/website-entities'

export interface WebsitePageBodyProps {
  entity: WebsitePageInterface
}

export const WebsitePageBody = ({ entity }: WebsitePageBodyProps) => {
  const layout = useWebsiteSettings(getWebsiteStylesLayout)
  const background = useWebsiteSettings(getWebsiteThemeBackground)

  return (
    <CommonWebsitePageBody
      htmlAttrId={entity.htmlAttrId}
      contentWidth={layout?.contentWidth}
      background={
        background?.containerBackgroundColor ||
        background?.contentBackgroundColor
      }
    >
      <ChildrenEntities childIds={entity.childIds} />
    </CommonWebsitePageBody>
  )
}
